import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeCitizensProceduresIndicatorB5Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class ResumeCitizenProceduresIndicatorB5Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";

	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalProcedures: number = 0;
	totalPreventProcedures: number = 0;
}

export async function getResumeCitizensProceduresIndicatorB5({
	uf,
	ibgeCode,
	...params
}: ResumeCitizensProceduresIndicatorB5Params) {
	const response = await esusApi.get<Paginated<ResumeCitizenProceduresIndicatorB5Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b5/resume-citizens-procedures`,
		params
	);
	return response.data ?? new Paginated<ResumeCitizenProceduresIndicatorB5Data>();
}
